<div class="map-loading-conteiner">
  <div *ngIf="(isLoaded$ | async) !== true" i18n>Loading map...</div>
  <div *ngIf="(isLoadedSourceData$  | async) !== true" i18n>Loading source data...</div>
  <div *ngIf="(isLoadedStyle$ | async) !== true" i18n>Loading style...</div>
</div>
<div id="app-map-container"></div>
